import { CreateUserSegmentInput } from 'api';
import { ARRAY } from 'constants/index';

export const createUserSegmentResponse = (values: CreateUserSegmentInput) => ({
  createUserSegment: {
    ...values,
    id: '-1',
    created_at: '-1',
    groups: ARRAY,
    group_ids: ARRAY,
    locations: ARRAY,
    location_ids: ARRAY,
    users: ARRAY,
    user_ids: ARRAY,
    departments: ARRAY,
    department_ids: ARRAY,
    email_addresses: ARRAY,
    __typename: 'UserSegment',
  },
});
